import { useTranslation } from "react-i18next";
import { Row, Col } from "../../App.styles";

const TimersSection = ({ useQuery }) => {
  const { t } = useTranslation();
  const { timer } = useQuery();

  return (
    <Row>
      <Col>
        <p dangerouslySetInnerHTML={{__html:`${t('Timer in seconds:')} ${{timer}}`}} />
      </Col>
    </Row>
  );
};

export default TimersSection;
